import React from 'react';
import LazyImage from '../common/LazyImage';
import uniform1 from '../../assets/media/photos/skyford_gallery_photo_4.webp';
import uniform2 from '../../assets/media/photos/skyford_gallery_photo_5.webp';
import uniform3 from '../../assets/media/photos/skyford_gallery_photo_23.webp';

const uniformData = [
  {
    id: 1,
    title: "Professional Excellence",
    description:
      "Our casual uniform represents a perfect balance of ease and professionalism, capturing the dynamic energy and passion of aviation.",
    image: uniform1,
  },
  {
    id: 2,
    title: "Aviation Excellence",
    description:
      "Our uniform sets a tone of professional excellence, crafted for comfort and style to ensure students are prepared for success.",
    image: uniform2,
  },
  {
    id: 3,
    title: "The Essence of Aviation",
    description:
      "Our aviation uniform embodies professionalism and discipline, crucial elements of success in the aviation industry.",
    image: uniform3,
  },
];

const Uniform = () => {
  return (
    <section className="py-16 sm:py-24 ">
      <div className="max-w-7xl mx-auto px-4">
        <div className="text-center mb-8 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl font-semibold  mb-6">Professional Excellence in Uniform</h2>
          <p className="text-gray-800 max-w-2xl mx-auto">
            Our uniform is more than just attire; it's a symbol of professionalism, style, and the unwavering spirit of aviation.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 sm:gap-16">
          {uniformData.map((uniform) => (
            <div key={uniform.id} className="relative bg-white rounded-3xl border">
              <div className="aspect-w-3 aspect-h-4 rounded-t-3xl overflow-hidden">
                <LazyImage
                  src={uniform.image}
                  alt={uniform.title}
                  className="w-full h-full aspect-[4/6]"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-medium text-red-900 mb-4">
                  {uniform.title}
                </h3>
                <p className="text-gray-600">{uniform.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Uniform;
